import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import "./HlzOffice.css";

const officeDat = [
  {
    id: 1,
    image: require('../images/ComponentImg/Office/AdministrateDepartment.jpg'),
    alt: 'images/ComponentImg/Office/AdministrateDepartment.jpg',
    title: 'Administrate Department',
  },
  {
    id: 2,
    image: require('../images/ComponentImg/Office/EngineerDepartment.jpg'),
    alt: 'images/ComponentImg/Office/EngineerDepartment.jpg',
    title: 'Engineering Department',
  },
  {
    id: 3,
    image: require('../images/ComponentImg/Office/FrontDesk.jpg'),
    alt: 'images/ComponentImg/Office/FrontDesk.jpg',
    title: 'Reception Front Desk',
  },
  {
    id: 4,
    image: require('../images/ComponentImg/Office/LobbyB.jpg'),
    alt: 'images/ComponentImg/Office/LobbyB.jpg',
    title: 'Lobby',
  },
  {
    id: 5,
    image: require('../images/ComponentImg/Office/OfficeTeam.jpg'),
    alt: 'images/ComponentImg/Office/OfficeTeam.jpg',
    title: 'Office Team Member',
  },
  {
    id: 6,
    image: require('../images/ComponentImg/Office/ProductWindow.jpg'),
    alt: 'images/ComponentImg/Office/ProductWindow.jpg',
    title: 'Products Show Window',
    // subtitle: 'Products Show Window'
    // link: 'https://www.google.com',
  },
]

export function HlzOffice() {
  return (
    <section id='office' className='office-block'>
      <Container fluid>
        <div className='title-holder text-center'>
          <h2>Our Office</h2>
        </div>
        <Row className='portfolio'> {
          officeDat.map(office => {
            return (
              <Col sm={4} key={office.id}>
                <div className='office-table'>
                  <a href={office.link}>
                    <img src={office.image} className='mt-5 mt-lg-0' alt="" />
                    <h5>{office.alt}</h5>
                    <div className='label text-center'>
                      <h3>{office.title}</h3>
                      <p>{office.subtitle}</p>
                    </div>
                  </a>
                </div>
              </Col>
            );
          })
        } </Row>
        {/* <Pagination>{items}</Pagination> */}
      </Container>
    </section>
  )
}

// import Image from 'react-bootstrap/Image';
// import Pagination from 'react-bootstrap/Pagination';

// import Office1 from '../images/ComponentImg/Office/AdministrateDepartment.jpg';
// import Office2 from '../images/ComponentImg/Office/EngineerDepartment.jpg';
// import Office3 from '../images/ComponentImg/Office/FrontDesk.jpg';
// import Office4 from '../images/ComponentImg/Office/LobbyB.jpg';
// import Office5 from '../images/ComponentImg/Office/OfficeTeam.jpg';
// import Office6 from '../images/ComponentImg/ProductWindow.jpg';

// <div className='title-holder text-center'>
//  <h2>Our Office</h2>
//  {/* <div className='subtitle text-center'><h3>Our Office Area</h3></div> */}
// </div>

// <section id='factory' className='block factory-block'>
// <div className='container py-5'>
//   {/* <h2 className='text-center fs-1 mb-5 fw-bold'>Office Area</h2> */}
//   <h2 className='text-center fs-1 mb-5'>Office Area</h2>
//   <div className='row'>
//     <div className='col-md-4 px-2'>
//       <div className='my-3'> <img src={Office1} className='img-fluid' alt="" /> </div>
//       <div className='my-3'> <img src={Office2} className='img-fluid' alt="" /> </div>
//     </div>
//     <div className='col-md-4 px-2'>
//       <div className='my-3'> <img src={Office3} className='img-fluid' alt="" /> </div>
//       <div className='my-3'> <img src={Office4} className='img-fluid' alt="" /> </div>
//     </div>
//     <div className='col-md-4 px-2'>
//       <div className='my-3'> <img src={Office5} className='img-fluid' alt="" /> </div>
//       <div className='my-3'> <img src={Office6} className='img-fluid' alt="" /> </div>
//     </div>
//   </div>
// </div>
// </section>

// <div className='office-table'>
//  <a href={office.link}>
//    <img src={office.image} className='mt-5 mt-lg-0' alt="" />
//    {/* <Image src={office.image} className='vh-80' /> */}
//    <div className='label text-center'>
//      <h3>{office.title}</h3>
//      <p>{office.subtitle}</p>
//    </div>
//  </a>
// </div>
